/* globals $ */

"use strict";



var invalidAddresses = [
  "gmail.com",
  "yahoo.com",
  "msn.com",
  "hotmail.com",
  "yandex.ru",
  "freemail.com",
];

$(".wpcf7-email").focus(function () {
  $(".business-email").remove();
});

$(".wpcf7-email").keydown(function () {
  $(".business-email").remove();
});

$(document).ready(function () {
  if (window.location.pathname == "/") {
    $('.progressive-profiling input[name ="utm_conversion_url"]').val("home");
  } else {
    $('.progressive-profiling input[name ="utm_conversion_url"]').val(
      window.location.pathname
    );
  }
});

$( window ).resize(function() {
  $("ul#menu-primary-nav > li").each(function(index) {
    var leftPos = $(this).position().left;
    index++;
    $("ul#menu-primary-nav").get(0).style.setProperty("--navLeft" + index, leftPos + 'px');
  });
});



$(document).ready(function () {
  $( "ul#menu-primary-nav > li[class*='menu-item']" ).each ( function (navCount) {
    var elClasses = $( this ).attr ( 'class' ).split ( ' ' );
    for ( var index in elClasses ) {
        if ( elClasses[index].match ( /^width-\d+$/ ) ) {
            var classNum = elClasses[index].split ( '-' )[1];
            $("ul#menu-primary-nav").get(0).style.setProperty("--navWidth" + (navCount + 1), classNum + 'px');
            break;
        }
    }
} );
  setTimeout(function () {
      $("ul#menu-primary-nav > li").each(function(index) {
        var leftPos = $(this).position().left;
        index++;
        $("ul#menu-primary-nav").get(0).style.setProperty("--navLeft" + index, leftPos + 'px');
      });
      $("ul#menu-primary-nav > li").addClass("removeMin")
    }, 50);

      $(".navbar.full-width").addClass("nav-loaded");

      $('.menu-item-has-children').mouseover(function(){
        setTimeout(function () {
          $(".navbar.full-width").addClass('activeNav');
        }, 250);
      }).mouseleave(function(){
        setTimeout(function () {
          $(".navbar.full-width").removeClass('activeNav');
        }, 250);
      });
    /* $(".navbar.full-width")
    .find("#menu-primary-nav > li.menu-item-has-children:not(.demo-btn)")
    .hover(function () {
      var leftShift = $(this).attr('data-left');
      var currWidth = $(this).attr('data-width');
      $("#menu-primary-nav").get(0).style.setProperty("--navLeft", leftShift + 'px');
      $("#menu-primary-nav").get(0).style.setProperty("--navWidth", currWidth + 'px');
    }); */
  // Initialize highlight js
  hljs.initHighlightingOnLoad();

  // Plugins filter
  $("a[data-filter]").click(function () {
    var value = $(this).data("filter");

    // Remove any active classes that may already be applied
    $(".plugin-filter a").removeClass("active");
    // Add active class sidebar li
    $(this).addClass("active");

    // For all faded cards, replace href with data-href value
    $(".plugin-card.fadeOut").each(function () {
      var link = $(this).find("a");
      link.attr("href", $(link).attr("data-href"));
      link.removeAttr("data-href");
    });

    // Remove any fade states that may already be applied
    $(".plugin-card").removeClass("fadeOut");

    // If the value of the li is not all continue
    if (value !== "all") {
      // Fade all cards that don't have matching filter
      $(".plugin-card")
        .not("." + value)
        .addClass("fadeOut");
      // For each faded card, move href to data-href and remove href
      $(".plugin-card.fadeOut").each(function () {
        var link = $(this).find("a");
        link.attr("data-href", $(link).attr("href"));
        link.removeAttr("href");
      });
    }
  });

  // Add Smooth scroll when link with attr clicked
  $('a[data-link="scroll"]').click(function () {
    $("html, body").animate(
      {
        scrollTop: $($.attr(this, "href")).offset().top - 86, // Add spacing on top after scroll
      },
      600
    ); // Adjust scroll speed
    return false;
  });

  // Collapse Toggler
  $('button[data-toggle="kong-expand"]').on("click", function (e) {
    e.stopPropagation();
    var $this = $(this);
    $("#oss_subnav.expand").toggleClass("slideup");
    $($this.data("target")).toggleClass("kong-navbar-collapse--expand");
    $("nav.navbar.full-width").toggleClass("kong-navbar-collapse--expand");
    $this.toggleClass("active").attr("aria-expanded", true);
    $(".kong-navbar-collapse_section").removeClass("shift");
    $(".subnav, .trigger, .remove").removeClass("active");
    setTimeout(function () {
      $("#menu-primary-nav li").removeClass("active");
      $(".active-tab").removeClass("active-tab");
    }, 100);
  });

  function closeMenu(e) {
    var target = e.target; // Get target
    var menu = $("nav.navbar.full-width"); // Get menu container
    var header = $("header.navbar"); // Get header
    var toggler = $(".navbar-toggler"); // Get menu toggle btn

    // if clicked target is not the menu container/decendent of menu container, toggler or header close
    if (
      !menu.has(target).length > 0 &&
      !menu.is(target) &&
      !header.is(e.target) &&
      !toggler.is(e.target)
    ) {
      $("nav.navbar.full-width").removeClass("kong-navbar-collapse--expand");
      $('button[data-toggle="kong-expand"]').removeClass("active");
    }
  }

  // Close mobile menu when clicked outside
  $(window).on("click", function (e) {
    closeMenu(e);
  });

  // Close mobile menu on esc click
  $(document).keyup(function (e) {
    if (e.keyCode == 27) {
      closeMenu(e);
    }
  });

  $(".progressive-profiling, #request_demo_form, .request_demo_form")
  .parent()
  .submit(function (event) {
    event.preventDefault();
    var emailAddress = $(this)
      .find(".wpcf7-form-control-wrap.email input")
      .val();
    var emailDomain = emailAddress.substr(emailAddress.search("@") + 1);
    if (jQuery.inArray(emailDomain, invalidAddresses) !== -1) {
      event.preventDefault();
      $('input[name ="utm_free"]').val("free");
      $('input[name ="personal_email_checkbox"]').val("true");
      $(this)
        .parents(
          ".progressive-profiling, #request_demo_form, .request_demo_form"
        )
        .parents(".wpcf7-form")
        .submit();
    } else {
      $(this)
        .parents(
          ".progressive-profiling, #request_demo_form, .request_demo_form"
        )
        .parents(".wpcf7-form")
        .submit();
    }
  });

  // Offscreen Subnav Triggers

  jQuery(".trigger").click(function () {
    jQuery(this).next().addClass("active");
    jQuery(".trigger, .remove").addClass("active");
    jQuery(".kong-navbar-collapse_section").addClass("shift");
  });
  jQuery(".back").click(function () {
    jQuery(".kong-navbar-collapse_section").removeClass("shift");
    jQuery(".subnav, .trigger, .remove").removeClass("active");
  });

  // Highlight install button on scroll
  /** var $installBtn = $(".kong-navbar").find(".btn-primary");
  $(window).on("scroll", function () {
    var scrollTop = $(this).scrollTop();
    if (scrollTop > 76) {
      $installBtn.addClass("btn-highlight");
    } else {
      $installBtn.removeClass("btn-highlight");
    }
  }); **/

  // Check for cookie
  if (
    !document.cookie.split(";").filter(function (item) {
      return item.indexOf("cookie-policy") >= 0;
    }).length
  ) {
    $(".cookie-policy-container").addClass("showing");
  }

  // Add body class if announcement is present
  if ($(".announcement-banner").length) {
    $("body").addClass("banner-visible");
  }

  jQuery(".navbar-item .list-group").hover(function () {
    jQuery(".kong-navbar").addClass("active");
  });
  jQuery(".navbar-item .list-group").mouseleave(function () {
    jQuery(".kong-navbar").removeClass("active");
  });

  var wpcf7Elm = jQuery(".wpcf7");

  for (var i = 0; i < wpcf7Elm.length; i++) {
    wpcf7Elm[i].addEventListener(
      "wpcf7mailsent",
      function (event) {
        var fid = $(this).attr("id");
        var redirect = false;
        var pardot_link = jQuery("#" + fid + " form.wpcf7-form")
          .find('input[name="pardot-link"]')
          .val();
        console.log(pardot_link);
        var emailVal = jQuery("#" + fid + " form.wpcf7-form")
          .find('input[name="email"]')
          .val();
        var conversionUrl = jQuery("#" + fid + " form.wpcf7-form")
          .find('input[name="utm_conversion_url"]')
          .val();
        var success_message = jQuery("#" + fid + " form.wpcf7-form")
          .find('textarea[name="success-message"]')
          .val();
        var webinar_date = jQuery("#" + fid + " form.wpcf7-form")
          .find('input[name="webinar-date"]')
          .val();
        var webinar_url = jQuery("#" + fid + " form.wpcf7-form")
          .find('input[name="webinar-url"]')
          .val();
        var submit_id = jQuery("#" + fid + " form.wpcf7-form")
          .find('input[type="submit"]')
          .attr("value");
        var getStartedEmail = jQuery(
          "#" + fid + " form.wpcf7-form .get-started"
        )
          .find('input[name="email"]')
          .val();
        localStorage.setItem("trialEmail", emailVal);
        localStorage.setItem("conversionURL", conversionUrl);
        jQuery.cookie("getStarted", getStartedEmail, { expires: 1, path: "/" });
        if (webinar_date) {
          var date1 = webinar_date;
          var date2 = Math.round(new Date().getTime() / 1000);
          if (date1 > date2) {
            if (success_message) {
              event.detail.apiResponse.message = "";
              setTimeout(function () {
                $(".wpcf7-response-output").append(success_message);
              }, 500);
              jQuery("#" + fid + " form.wpcf7-form")
                .find('textarea[name="success-message"]')
                .val("");
              jQuery("#webinar_form").hide();
            }
          } else {
            if (webinar_url) {
              redirect = true;
            } else if (!webinar_url && success_message) {
              event.detail.apiResponse.message = "";
              setTimeout(function () {
                $(".wpcf7-response-output").append(success_message);
              }, 500);
              jQuery("#" + fid + " form.wpcf7-form")
                .find('textarea[name="success-message"]')
                .val("");
              jQuery("#webinar_form").hide();
            }
          }
        } else if (webinar_url) {
          redirect = true;
        } else if (success_message) {
          event.detail.apiResponse.message = "";
          setTimeout(function () {
            $(".wpcf7-response-output").append(success_message);
          }, 500);
          $(".wpcf7-response-output").html(success_message);
          jQuery("#" + fid + " form.wpcf7-form")
            .find('textarea[name="success-message"]')
            .val("");
          jQuery(
            "#webinar_form, #ebook_form, #request_demo_form, #invitation_list_form, .request_demo_form"
          ).hide();
          jQuery(".card .mini").hide();
        }

        dataLayer.push({
          event: "wpcf7successfulsubmit",
          CF7formID: submit_id,
        });

        jQuery.ajax({
          url: pardot_link,
          type: "POST",
          dataType: "jsonp",
          crossDomain: true,
          async: false,
          data: jQuery("#" + fid + " form.wpcf7-form").serialize(),
          xhrFields: {
            withCredentials: true,
          },
          success: function () {
          },
        });


        if (redirect) {
          window.location = webinar_url;
        }
      },
      false
    );
  }

  var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
      sURLVariables = sPageURL.split("&"),
      sParameterName,
      i,
      x;
    var status = false;
    var urlParams = [
      "utm_source",
      "utm_campaign",
      "utm_medium",
      "utm_content",
      "utm_term",
      "gclid",
      "GCLID"
    ];
    var paramValues = [];
    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split("=");

      if (jQuery.inArray(sParameterName[0], urlParams) >= 0) {
        setCookie(sParameterName[0], sParameterName[1], 0);
        paramValues.push(sParameterName[0]);
        status = true;
      }
    }

    if (status == true) {
      for (i = 0; i < urlParams.length; i++) {
        if (jQuery.inArray(urlParams[i], paramValues) < 0) {
          setCookie(urlParams[i], " ", 0);
        }
      }
    }

    for (x = 0; x < urlParams.length; x++) {
      if (getCookie(urlParams[x])) {
        jQuery('input[name="' + urlParams[x] + '"]').val(

          getCookie(urlParams[x])
        );
        var lowerParam = urlParams[x];
        var lowerCaseParam = lowerParam.toLowerCase();
        jQuery('input[name="' + lowerCaseParam + '"]').val(
          getCookie(urlParams[x])
        );
      }
    }
  };

  getUrlParameter();

  function setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + 5 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  $(window).resize(function () {
    if ($(window).width() <= 768) {
      $(".ebook_page_header_image").remove().insertAfter($(".ebook-form"));
    } else {
      $(".ebook_page_header_image").remove().insertBefore($(".ebook-form"));
    }
  });



});

var $window = $(window);

function checkWidth() {
  var windowsize = $window.width();
  if (windowsize > 1080) {
    $(".navbar").removeClass("mobile-triggers");
    $("#menu-primary-nav li").removeClass("active");
    $(".active-tab").removeClass("active-tab");
  } else {
    $(".navbar").addClass("mobile-triggers");
  }
  if (
    (/\b(iPad)\b/.test(navigator.userAgent) &&
      /WebKit/.test(navigator.userAgent) &&
      !window.MSStream) ||
    (navigator.platform === "MacIntel" &&
      navigator.maxTouchPoints &&
      navigator.maxTouchPoints === 5)
  ) {
    $(".navbar").addClass("mobile-triggers");
  }
}
// Execute on load
checkWidth();
// Bind event listener
$(window).resize(checkWidth);

$("#menu-primary-nav .nav1 > a").click(function () {
  if ($("nav.navbar").hasClass("mobile-triggers")) {
    event.preventDefault();
    $(".nav3").removeClass("active");
    var position = $(this).parent().position();
    $(this).parent().toggleClass("active");
    $("body")
      .get(0)
      .style.setProperty("--navPosition", (position.top - 75) * -1 + "px");
    $(this).parent().parent().toggleClass("active-tab");
  }
});

$("#menu-primary-nav .nav3 > a").click(function () {
  if ($("nav.navbar").hasClass("mobile-triggers")) {
    event.preventDefault();
    $(this).parent().toggleClass("active");
  }
});

var wpcf7Confirmation = document.querySelector(".wpcf7");

wpcf7Confirmation.addEventListener(
  "wpcf7mailsent",
  function (event) {
    $(".single_line_form.custom_confirmation").addClass("submitted");
  },
  false
);

$(".wpcf7-submit, form .btn-block").click(function () {
  try {
    var clearbitForm = $(this).closest("form");
    var clearbitEmail = $("input[name=email]", clearbitForm).val();
    clearbit.identify(clearbitEmail, {
      email: clearbitEmail,
    });
  } catch (err) {
    console.log("identify error");
  }
});
